/* eslint-disable no-restricted-syntax */
export default function getFileNameFromHeader(header) {
  const contentDispostion = header.split(';')
  const fileNameToken = `filename*=UTF-8''`

  let fileName = 'downloaded.pdf'
  for (const thisValue of contentDispostion) {
    if (thisValue.trim().indexOf(fileNameToken) === 0) {
      fileName = decodeURIComponent(thisValue.trim().replace(fileNameToken, ''))
      break
    }
  }

  return fileName
}
